const ShareIcon = ({ startColor = "#ff7e5f", endColor = "#feb47b" }) => {
  const gradientId = `shareIconGradient-${startColor}-${endColor}`;

  return (
    <svg
      className="w-8 h-8"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
      <g>
        <g>
          <path
            d="M429.911,15.329c-45.264,0-82.088,36.825-82.088,82.089c0,7.339,0.982,14.451,2.798,21.226l-201.03,90.717
			c-14.832-21.399-39.55-35.45-67.5-35.45C36.825,173.911,0,210.736,0,256c0,45.264,36.825,82.089,82.089,82.089
			c27.956,0,52.68-14.058,67.511-35.465l137.625,62.051c1.361,0.614,2.784,0.904,4.186,0.904c3.888,0,7.602-2.236,9.304-6.009
			c2.315-5.135,0.029-11.175-5.106-13.49l-136.546-61.563c3.304-8.888,5.116-18.493,5.116-28.516c0-10.029-1.815-19.64-5.122-28.531
			l199.278-89.926c14.081,25.019,40.879,41.966,71.575,41.966c45.264,0,82.089-36.825,82.089-82.089
			C511.999,52.155,475.175,15.329,429.911,15.329z M140.399,276.102l-20.081-9.054c1.016-3.51,1.572-7.214,1.572-11.048
			c0-21.947-17.855-39.8-39.801-39.8c-21.947,0-39.8,17.855-39.8,39.8s17.855,39.8,39.8,39.8c10.712,0,20.442-4.261,27.604-11.168
			l20.897,9.422c-11.304,14.377-28.835,23.637-48.5,23.637c-34.016,0-61.691-27.675-61.691-61.691s27.674-61.691,61.691-61.691
			c34.016,0,61.691,27.674,61.691,61.691C143.78,263.037,142.58,269.795,140.399,276.102z M101.492,256
			c0,10.699-8.704,19.402-19.403,19.402S62.687,266.698,62.687,256s8.704-19.402,19.402-19.402S101.492,245.301,101.492,256z
			 M429.911,159.11c-22.433,0-42.103-12.04-52.901-29.995l20.163-9.099c7.189,10.384,19.18,17.204,32.738,17.204
			c21.948,0,39.801-17.855,39.801-39.8s-17.855-39.8-39.801-39.8s-39.8,17.855-39.8,39.8c0,1.125,0.058,2.236,0.15,3.337
			l-20.722,9.351c-0.86-4.097-1.319-8.34-1.319-12.689c0-34.016,27.674-61.691,61.69-61.691c34.017,0,61.692,27.675,61.692,61.691
			C491.602,131.435,463.927,159.11,429.911,159.11z M410.508,97.419c0-10.699,8.704-19.402,19.402-19.402
			c10.699,0,19.403,8.704,19.403,19.402s-8.704,19.402-19.403,19.402C419.212,116.822,410.508,108.118,410.508,97.419z"
            fill={`url(#${gradientId})`}
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M332.618,362.781l-5.288-2.386c-5.139-2.315-11.175-0.032-13.493,5.102c-2.316,5.134-0.033,11.175,5.102,13.492
			l5.288,2.386c1.363,0.614,2.786,0.905,4.189,0.905c3.887,0,7.6-2.234,9.303-6.007
			C340.037,371.138,337.753,365.097,332.618,362.781z"
            fill={`url(#${gradientId})`}
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M429.911,332.492c-45.264,0-82.088,36.825-82.088,82.089c0,45.264,36.824,82.089,82.088,82.089S512,459.845,512,414.581
			C512,369.317,475.175,332.492,429.911,332.492z M429.911,476.272c-34.016,0-61.69-27.675-61.69-61.691s27.674-61.691,61.69-61.691
			c34.017,0,61.691,27.674,61.691,61.691S463.927,476.272,429.911,476.272z"
            fill={`url(#${gradientId})`}
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M429.911,374.78c-21.947,0-39.8,17.855-39.8,39.8s17.855,39.8,39.8,39.8c21.948,0,39.801-17.855,39.801-39.8
			S451.857,374.78,429.911,374.78z M429.911,433.983c-10.698,0-19.402-8.704-19.402-19.402c0-10.698,8.704-19.402,19.402-19.402
			c10.699,0,19.403,8.704,19.403,19.402C449.314,425.279,440.61,433.983,429.911,433.983z"
            fill={`url(#${gradientId})`}
          />
        </g>
      </g>
    </svg>
  );
};

export default ShareIcon;
